import { useEffect, useState } from 'react';
import { useLocation } from "react-router-dom";
import Storage from '../../session/storage';
import api from '../../service/api';
import ProgressBar from '../progress/progressBar';
import ConfirmationDialogRaw from './popup-static';
import EmployerConfig from '../../config/EmployerPopupConfig.json';
import AddNewEmployerForm from './employer-form';

const AddNewEmployer = (props) => {
  const location = useLocation();
  const rest = location.state || {};
  const { country, user, classificationCode } = rest;
  const [allCountry, setAllCountry] = useState(Storage.getAllCountryList());
  const [selectedCountry, setSelectedCountry] = useState(country || '');
  const [selectedClassificationCode, setSelectedClassificationCode] = useState(classificationCode ? EmployerConfig.classificationCodes.find((code) => code.value === classificationCode) : '');

  const [showPopup, setShowPopup] = useState(false)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (allCountry === null || allCountry === undefined) {
      setLoading(true)
      const user = Storage.getUserData()
      if(!user?.isEmployerAccess){
        window.location.href = '/'
      }
      async function fetchDetails() {
        await api.getSelectedDCRCountry().then((countryList) => {
          var countryListData = countryList.data
          Storage.setAllCountryList(countryList.data)
          setAllCountry(countryListData)
          setTimeout(() => {
            setLoading(false);
          }, 4000);
        }).catch((error) => {
          setLoading(false);
        })
      }

      fetchDetails();
    }

    if(country && classificationCode){
      setSelectedCountry(country)
      setSelectedClassificationCode(EmployerConfig.classificationCodes.find((code) => code.value === classificationCode))
    } else {
      setShowPopup(true)
    }
  }, [])

  function handleOk(value) {
    const { country, classificationCode } = value
    setSelectedCountry(country)
    setSelectedClassificationCode(classificationCode)
    setShowPopup(false)
  };

  function cancelPopUp(isEdit = false) {
    setShowPopup(false)
    if (!isEdit)
      window.history.back(-1)
  }

  function openPopup() {
    setShowPopup(true)
  }

  function showComponent() {
    if (allCountry === null || allCountry === undefined) {
      window.history.back(-1)
    } else {
      if (showPopup) {
        return <ConfirmationDialogRaw
          id="static-popup"
          open={showPopup}
          onOk={(value) => handleOk(value)}
          onCancel={() => cancelPopUp()}
          option={EmployerConfig.raw_countries}
          vendor={false}
          user={user}
          entity={"Employer"}
          selectedClassificationCode={selectedClassificationCode}
          selectedCountry={EmployerConfig.raw_countries.filter((option) => option === 'United States')}
        />;
      } else {
        return (
          <AddNewEmployerForm
            openPopup={openPopup}
            country={selectedCountry}
            classificationCode={selectedClassificationCode}
            user={user}
            props={props}
            allCountry={allCountry}
            entityType={EmployerConfig.classificationCodes.find((type) => type.value === selectedClassificationCode)?.entity_type}
          />
        )
      }
    }
  }
  return (
    <>
      {loading && (
        <div className="extra-margin-top d-flex justify-content-center body-height">
          <ProgressBar />
        </div>
      )}
      {!loading && allCountry && showComponent()}
    </>
  )
}

export default AddNewEmployer
